import React, { useState } from "react";
import styled from "styled-components";
import bg from "../../images/auth-bg.svg";
import signin from "../../images/signin.svg";
import lock from "../../images/lock.svg";
import { UseAuthContext } from "../../store/contexts/auth.context";
import { NavLink } from "react-router-dom";
import AuthWrapper from "./AuthWrapper";

function SignIn() {
  const [message, setmessage] = useState();
  const [errors, seterrors] = useState({
    email: null,
    password: null,
  });
  const { signIn: AuthHandler } = UseAuthContext();
  const submitHandler = async (e) => {
    e.preventDefault();
    const email = e.target.email.value;
    const password = e.target.password.value;
    if (!email.includes("@") || password.length < 5) {
      return seterrors({
        email: !email.includes("@"),
        password: password.length < 5,
      });
    }
    seterrors({ email: null, password: null });
    const res = await AuthHandler(email, password);
    setmessage(res.message);
  };
  return (
    <AuthWrapper bg={bg}>
      <Wrapper>
        <img src={signin} alt="" />
        <div>
          <img src={lock} alt="" />
          <h1>Sign In</h1>
          {message && <p style={{ color: "red" }}>{message}</p>}
          <form onSubmit={submitHandler}>
            <input
              type="email"
              className={`${errors.email ? "error" : ""} form-input`}
              name="email"
              placeholder="Email Address"
            />
            <small>
              <NavLink to={"/recovery"}>Forgot password?</NavLink>
            </small>
            <input
              type="password"
              className={`${errors.password ? "error" : ""} form-input`}
              name="password"
              placeholder="Password"
            />
            <input type="submit" className="form-input" value="SIGN IN" />
            <p>
              Do you not have account yet? <br />
              <NavLink to={"/signup"}>Sign Up Now!</NavLink>
            </p>
          </form>
        </div>
      </Wrapper>
    </AuthWrapper>
  );
}

export default SignIn;

const Wrapper = styled.main`
  small {
    text-align: left;
    font-size: 13px;
    margin-top: -6px !important;
    margin-bottom: 2px !important;
  }
`;
